import { ReactElement, useState } from "react";
import { Tab } from "@remo-co/ui-core/src/components/Tab";
import { Tabs } from "@remo-co/ui-core/src/components/Tabs";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Lottie } from "@remo-co/ui-core/src/components/Lottie";
import { useI18n } from "i18n";
import useStyles from "./PreviewPanel.styles";
import { EventOption } from ".";
import EventSwitcher from "../EventSwitcher";
import AnimationData from "../../assets/animation.lottie.json";

const PREVIEW_TAB = "preview";
const HOW_IT_WORKS_TAB = "how-it-works";

interface IPreviewPanelProps {
  name: string;
  eventArray: EventOption[];
}

const PreviewPanel = ({
  name,
  eventArray,
}: IPreviewPanelProps): ReactElement => {
  const [selectedTab, setSelectedTab] = useState("preview");
  const styles = useStyles();
  const { t } = useI18n(["eventDirectory"]);

  const handleTabChange = (_e: unknown, value: string) => {
    setSelectedTab(value);
  };

  return (
    <Container className={styles.contentRight}>
      <Tabs
        value={selectedTab}
        className={styles.tabs}
        onChange={handleTabChange}
      >
        <Tab
          disableRipple
          label={t("eventDirectory:preview")}
          id="tab-preview"
          className={styles.tab}
          value={PREVIEW_TAB}
        />
        <Tab
          disableRipple
          label={t("eventDirectory:how.it.works")}
          id="tab-how-it-works"
          className={styles.tab}
          value={HOW_IT_WORKS_TAB}
          data-testid="how-it-works-tab"
        />
      </Tabs>
      <Container className={styles.tabContent}>
        {selectedTab === PREVIEW_TAB && (
          <EventSwitcher
            title={
              eventArray[0]
                ? `${eventArray[0].name}`
                : t("eventDirectory:no.event.selected")
            }
            previewEvents={eventArray}
            previewName={name || t("eventDirectory:directory.name")}
          />
        )}
        {selectedTab === HOW_IT_WORKS_TAB && (
          <Container className={styles.animationContainer}>
            <Lottie
              animationData={AnimationData}
              className={styles.animationSvg}
            />
          </Container>
        )}
      </Container>
    </Container>
  );
};

export default PreviewPanel;
